import { api } from "services/api.service";
import { LoaderFunctionArgs } from "react-router-dom";
import { withAuth } from "routes/utils/withAuth";

export const loader = withAuth(async ({ params }: LoaderFunctionArgs) => {
  const { data: pickup } = await api.get(`/pickups/${params.pickupId}`);
  return { pickup };
});
